import React, { FC, memo } from 'react'
import Image from '@sport1/news-styleguide/Image'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { Trademark } from './types/Trademark'

type Props = {
    trademark: Required<Trademark>
}

const FooterTrademark: FC<Props> = ({ trademark }) => {
    const iconUrl = trademark.iconUrl

    const image = (
        <Image
            size="S"
            key={iconUrl}
            imageUrl={iconUrl}
            alt={trademark.title}
            aspectRatio={trademark.width / trademark.height}
            resizeMode="contain"
        />
    )

    return (
        <NonFlexingContainer
            width={['83.25px', '110px', '110px', '119.5px']}
            className="list-none"
            center
        >
            {trademark.targetUrl ? (
                <a href={trademark.targetUrl} target={trademark.target} rel={trademark.rel}>
                    {image}
                </a>
            ) : (
                image
            )}
        </NonFlexingContainer>
    )
}

export default memo(FooterTrademark)
